import { useEffect, useRef } from 'react';
import { useAuthContext } from '@/contexts/AuthContext';

export function AppUsageTracker(): null {
    const { user, profile, updateProfile } = useAuthContext();
    const hasUpdatedRef = useRef(false);

    useEffect(() => {
        if (!user || !profile || hasUpdatedRef.current) return;

        const now = new Date();
        const lastSeen = profile.lastSeenAt ? new Date(profile.lastSeenAt) : null;

        const SHOULD_UPDATE_THRESHOLD_MS = 30 * 60 * 1000;
        const shouldUpdateLastSeen = !lastSeen || (now.getTime() - lastSeen.getTime() > SHOULD_UPDATE_THRESHOLD_MS);

        const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
        const shouldUpdateTimezone = profile.timezone !== currentTimezone;

        if (shouldUpdateLastSeen || shouldUpdateTimezone) {
            hasUpdatedRef.current = true;
            console.log('[AppUsageTracker] Updating profile:', { shouldUpdateLastSeen, shouldUpdateTimezone });

            updateProfile({
                lastSeenAt: shouldUpdateLastSeen ? now : undefined,
                timezone: shouldUpdateTimezone ? currentTimezone : undefined,
            }).then(({ error }) => {
                if (error) {
                    console.error('[AppUsageTracker] Update failed:', error);
                    // Allow retry after error, but with a delay
                    setTimeout(() => { hasUpdatedRef.current = false; }, 5 * 60 * 1000);
                }
            });
        }
    }, [user, profile, updateProfile]);

    return null;
}
